module.exports = __webpack_public_path__ + "static/finance_made_simple_logo-d892b592106dc3820238eda1283d87e7.jpg";